import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, FormFeedback, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import UsersSelected from './UsersSelected';
import { toast } from 'react-toastify';
import { sendNotification } from 'src/services/notification-manage-service';
import { getUsers } from 'src/services/users-service';
import { AsyncPaginate } from 'react-select-async-paginate';
import FeatherIcon from "feather-icons-react";

interface IProps {
    refreshTable: () => void;
    isOpenCreateNotification?: boolean;
}

export const CreateNotificationComponent = ({ refreshTable, isOpenCreateNotification }: IProps) => {

  const [usersSelected, setUsersSelected] = useState<{label: string, value: string, error?: string}[]>([]);
  const [title, setTitle] = useState<string>('');
  const [body, setBody] = useState<string>('');
  const [titleError, setTitleError] = useState<boolean>(false);
  const [bodyError, setBodyError] = useState<boolean>(false);
  const [isSelectAllUsers, setIsSelectAllUsers] = useState<boolean>(false);
  const [status, setStatus] = useState<{ success_count: number, failure_count: number } | null>(null);
  const [loadingSendNotification, setLoadingSendNotification] = useState(false);
  const [value, setValue] = useState<any>(null);

  async function loadOptions(search: string, loadedOptions: any, { page }: { page: number }) {
    const response = await getUsers({ page, per_page: 20, search }, 'all');
    if (response.result !== 'ok') {
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
    const responseJSON = {
      results: response.data.data.map((user) => ({
        value: user.id,
        label: user.firstName + ' ' + user.lastName + (user.email ? ` (${user.email})` : ''),
      })),
      has_more: page * response.data.pagination.per_page < response.data.pagination.total,
    };
    return {
      options: responseJSON.results,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    };
  }

  const onSelectUser = (user: { label: string, value: string }) => {
    console.log(user);
    setUsersSelected(prev => {
      if (prev.find(u => u.value === user.value)) {
        toast.error('User already selected');
        return prev; // User already selected, do not add again
      }
      return [...prev, {...user, error: 'error asqui error aquisndkjsnfksdn fkjns djkfsdf'}];
    });
  }

  const onSendNotification = async () => {
    if (usersSelected.length === 0 && !isSelectAllUsers) {
      toast.error('Please select at least one user');
      return;
    }
    if (title.trim() === '') {
      setTitleError(true);
      return;
    } else {
      setTitleError(false);
    }
    if (body.trim() === '') {
      setBodyError(true);
      return;
    } else {
      setBodyError(false);
    }
    setLoadingSendNotification(true);
    setStatus(null);
    const res = await sendNotification({ userIds: usersSelected.map(u => u.value), title, body, isSelectAllUsers });
    setLoadingSendNotification(false);
    if (res.result === 'ok') {
        setStatus(res?.data?.status || null);
        refreshTable();
        setUsersSelected([]);
        setTitle('');
        setBody('');
        setValue(null);
        setIsSelectAllUsers(false);
        toast('Notifications sent', { type: 'success'});
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  useEffect(() => {
    if(isOpenCreateNotification === false) {
        setUsersSelected([]);
        setTitle('');
        setBody('');
        setValue(null);
        setIsSelectAllUsers(false);
        setStatus(null);
    }
  }, [isOpenCreateNotification]);


  return (
    <div>
      <Row className="">
        <Col sm={12} className="" >
            <Row className="mb-2">
            <Col sm={6} className="" >
                <div style={{ fontWeight: 'bold' }}>Users:</div>
            </Col>
            <Col sm={6} className="" >
                <FormGroup switch className="d-flex justify-content-end align-items-center gap-2">
                <Input
                    type="switch"
                    checked={isSelectAllUsers}
                    onClick={() => {
                    setIsSelectAllUsers(!isSelectAllUsers);
                    }}
                />
                <Label style={{marginTop: '5px'}} check>All Users</Label>
                </FormGroup>
            </Col>
            </Row>
            <div className="border rounded gap-3 p-2" style={{ width: '100%', backgroundColor: '#f8f9fa' }} >
            <AsyncPaginate
                value={value}
                loadOptions={loadOptions}
                onChange={onSelectUser}
                additional={{
                page: 1,
                }}
                placeholder="Search for name or email..."
            />
            </div>
        </Col>
        </Row>
        <Row className=" mt-2">
        <Col sm={6} className="" >
            <div className="d-flex align-items-center justify-content-between">
                <div style={{ fontWeight: 'bold' }}>Users selected:</div>
                {
                    !isSelectAllUsers && <small style={{ fontWeight: 'lighter', marginRight: '8px' }}> {usersSelected.length} selected</small>
                }
                </div>
            <div className="border rounded gap-3 p-2" >
                <UsersSelected
                    usersSelected={usersSelected}
                    onRemoveUser={(user) => setUsersSelected(prev => prev.filter(u => u.value !== user.value))}
                    isSelectAllUsers={isSelectAllUsers}
                />
            </div>
        </Col>
        <Col sm={6} className="" >
            <div style={{ fontWeight: 'bold' }}>Notification:</div>
            <div className="border rounded gap-3 p-2 " style={{ width: '100%', minHeight: '318px' }} >
            <FormGroup>
                <div>
                <Label for="title">
                    Title
                </Label>
                <Input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    invalid={titleError}
                    id="title"
                    placeholder="Enter title"
                    type="text"
                    
                />
                <FormFeedback invalid={!titleError}>
                    Title is required
                </FormFeedback>
                </div>
                <div className="mt-1">
                <Label for="body">
                    Body
                </Label>
                <Input
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    invalid={bodyError}
                    id="body"
                    placeholder="Enter body"
                    type="textarea"
                />
                <FormFeedback invalid={!bodyError}>
                    Body is required
                </FormFeedback>
                </div>
                {
                status && (status.failure_count > 0 || status.success_count > 0) &&
                <Alert color={status.failure_count > 0 ? "danger" : "success"} isOpen={status.failure_count > 0 || status.success_count > 0} toggle={() => setStatus(null)} className="mt-3">
                    <div style={{ fontWeight: 'bold' }}>Status:</div>
                    <div>
                    <span style={{ color: 'green', fontWeight: 'bold' }}>{status.success_count} Success</span> | <span style={{ color: 'red', fontWeight: 'bold' }}>{status.failure_count} Failed</span>
                    </div>
                </Alert>
                }
                <div className="d-flex justify-content-center mt-3">
                <Button
                    color="success"
                    outline
                    onClick={(e) => (onSendNotification(), e.currentTarget.blur())}
                >
                    <span style={{marginRight: '10px'}}>Send Notification</span>
                    <FeatherIcon icon="send" />
                </Button>
                </div>
            </FormGroup>
            </div>
        </Col>
        </Row>
        {
        loadingSendNotification &&
        <div style={{ position: 'absolute', backgroundColor: 'rgba(0, 0, 0, 0.5)', top: 0, left: 0, right: 0, bottom: 0, borderRadius: '8px' }} className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', padding: '10px', borderRadius: '8px' }}>
            <Spinner color="light" />
            <b style={{marginLeft: '10px', color: 'white'}}>Sending Notification...</b>
            </div>
        </div>
        }
    </div>
  )
}